import Http from '@/utils/http'

const LOCATION_URL = '/locations/'

export const postLocation = (data) => Http.post(LOCATION_URL, data)
export const getLocation = (id) => {
  return Http.get(`${LOCATION_URL + id}/`)
}
export const getLocations = () => Http.get(LOCATION_URL)
export const deleteLocation = (id) => {
  return Http.delete(`${LOCATION_URL + id}/`)
}
export const putLocation = (data) => {
  return Http.put(`${LOCATION_URL + data.id}/`, data)
}



// WEBPACK FOOTER //
// ./src/services/location.js